module.exports = __webpack_public_path__ + "media/src/images/empty-dish-766eda50c3731260d00d7d793f078841.png";